<template>
	<section class="blocks" :class="bg_resp_color" id="block6" :style="{ backgroundImage: 'url(' + figure + ')' }">
		<div class="container">
			<div class="content-block6">
				<div class="empty"></div>
				<div class="article">
					<h2 class="title-box left">{{ title }}</h2>
					<article v-html="content">
						{{ content }}
					</article>

					<figure class="mobile">
						<img :src="resp_image" :alt="title">
					</figure>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color", "resp_image", "bg_resp_color"]
    }
</script>

<style lang="scss">
	#block6 {
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		min-height: 500px;
		display: flex;
		align-items: center;

		&.CINZA_ESCURO {

			.content-block6 {
				.article {
					h2 {
						color: #ffffff;
					}
				}
			}
		}

		.content-block6 {
			display: flex;
			flex-basis: 100%;

			.empty {
				flex-basis: 55%;
			}

			.article {
				flex-basis: 45%;
				margin-top: 30px;

				h2 {
					color: #000000;
				}
				article {


					ul {
						li {
							margin-bottom: 10px;
							color: #ffffff;
							font-size: 1.6em;
							font-weight: 100;
							line-height: 24px;
							font-family: 'Ubuntu', 'Arial', 'Tahoma', serif;

							a {
								color: #ffffff;
							}
						}
					}

					p {
						color: #ffffff;
						font-size: 1.6em;
						line-height: 24px;
						margin-bottom: 25px;
						font-weight: 100;
					}
				}
			}
		}

		figure {
			padding: 40px 0;
			text-align: center;
		}
	}

	@media (max-width: 767px) {
		#block6 {
			.content-block6 {
				.empty {
					display: none;
				}

				.empty {
					display: none;
				}

				.article {
					flex-basis: 100%;
				}

			}

			&.CINZA_CLARO {
				background-image: none !important;
				background-color: #eeeeee;
				background-position: center;
				padding-top: 10px;

				h2 {
					width: 90%;
					margin: 0 0 0 30px;
				}

				article {
					width: 90%;
					margin: 60px auto 50px auto;
				}

				figure {
					padding: 0;
				}

				.container {
					padding: 0;
					width: 100%;
				}
			}
		}
	}

	@media (max-width: 640px) {
		#block6 {
			padding: 0;

			&.CINZA_ESCURO {
				background-image: none !important;
				background-color: #333333;
				background-position: center;
				padding: 0;

				h2 {
					width: 90%;
					margin: 30px 0 0 30px;
					color: #ffffff !important;
				}

				article {
					width: 90%;
					margin: 60px auto 50px auto;
				}

				figure {
					padding: 0;

					img {
						width: 100%;
						margin-bottom: -5px;
					}

				}

				.container {
					padding: 0;
					width: 100%;
				}
			}

			.content-block6 {
				.empty {
					display: none;
				}

				.empty {
					display: none;
				}

				.article {
					flex-basis: 100%;
				}

			}

			&.CINZA_CLARO {
				background-image: none !important;
				background-color: #eeeeee;
				background-position: center;
				padding-top: 10px;

				h2 {
					width: 90%;
					margin: 0 0 0 30px;
				}

				article {
					width: 90%;
				}

				figure {
					padding: 0;

					img {
						width: 100%;
						margin-bottom: -2px;
					}
				}

				.container {
					padding: 0;
					width: 100%;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/shared/blocks/Block6.vue